import { ActionTypes }    from 'actions/types';
import { menusStateType } from 'reducer/types';


export const initialMenusState: menusStateType = {
    openDropDown: 'new',
    openItem:     'noDisplay'
  };

const menusReducer = (state = initialMenusState, action: ActionTypes) => {

    switch (action.type) {

    case 'SET_MENUS_STATE':
      {
        return {
          ...state,
          ...action.payload
        }
      }


      case 'SET_OPEN_ITEM':
      {
        return {
          ...state,
          openItem: action.payload
        }
      }

    default: return state;
  }
};

export type reducerType = ReturnType<typeof menusReducer>;

export { menusReducer };

  